import { addClinicCopy } from './addClinic';

/** Copy for the prescriber's REMS certification: the steps the Certification Checklist tracks and the first three. */
export const remsEnrollmentCopy = {
  title: 'FINTEPLA® REMS Prescriber Certification',
  description: 'Verify your information for your REMS certification.',
  checklist: {
    title: 'Certification checklist',
    steps: {
      prescriber: 'Prescriber information',
      clinic: 'Clinic information',
      officeContact: 'Primary office contact',
      assessment: 'Knowledge assessment',
      signature: 'Signature',
    },
  },
  prescriber: {
    title: 'Prescriber information',
    npi: {
      label: 'Match NPI',
      helperText: '10-digit National Provider Identifier',
      /** A valid NPI that matches no prescriber on file. */
      noMatch: 'No prescriber matches that NPI. Check the number and try again.',
    },
    labels: { npi: 'NPI', specialty: 'Specialty', email: 'Email', phone: 'Phone' },
    missingValue: '-',
    confirm: 'Confirm',
    edit: 'Edit',
  },
  clinic: {
    title: 'Clinic information',
    description: 'The primary clinic location where you will be prescribing FINTEPLA.',
    select: 'Select clinic',
    labels: { phone: 'Phone', fax: 'Fax' },
    missingValue: '-',
    missingInformation: {
      title: 'Our records are missing some information required for REMS certification.',
      body: 'Please add the additional information.',
    },
    placeholders: { phone: '(000) 000-0000', fax: '(000) 000-0000' },
    addClinic: addClinicCopy.action,
    inProcess: 'In Process',
    confirm: 'Confirm',
  },
  officeContact: {
    title: 'Primary office contact',
    description: 'Enter the info for the point of contact regarding this prescriber’s enrollment.',
    labels: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      preferredCommunicationMethod: 'Preferred communication method',
      fax: 'Fax',
    },
    placeholders: { phone: '(000) 000-0000', preferredCommunicationMethod: 'Select one…', fax: '(000) 000-0000' },
    optional: 'Optional',
    missingValue: '-',
    contactMethods: { Email: 'Email', Phone: 'Phone', Fax: 'Fax' },
    confirm: 'Confirm',
    edit: 'Edit',
  },
} as const;
